<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> بوفه </span>

    </div>

</div>

<main class=" rtl py-3 px-2">

    <span *ngIf="list_Buffet.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Buffet.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 col-md-10 p-3">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div class="col-12 col-md-2 d-flex align-items-center">

            <button class="btn mx-2 px-5 w-100 btn-primary" (click)="openModal('newProduct')"> افزودن </button>

        </div>

        <div class="table-responsive" style="max-height: 76vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th>#</th>

                        <th class="col-1">عملیات</th>

                        <th> تصویر </th>

                        <th> عنوان </th>

                        <th> قیمت </th>

                        <th> تاریخ آخرین ویرایش </th>

                        <th> وضعیت </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Buffet;let i = index">

                        <th>{{ i + 1 | faNum }}</th>

                        <td class="col-1">

                            <i class="fa fa-trash-o fa-lg mt-2 px-3 btn btn-danger" (click)="deleteBuffet(item)" title="حذف"></i>

                            <i  class="fa fa-pencil-square-o fa-lg my-2 ms-2 btn btn-primary" title=" ویرایش " (click)="editBuffet(item)"></i>

                        </td>

                        <td><img class="rounded-circle" width="50" height="50" src="{{item.strImage.trim() != '' ? 'data:image/jpeg;base64,' + item.strImage : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}" [alt]="item.strTitle"> </td>

                        <td>{{item.strTitle}}</td>

                        <td>{{item.iPrice.toLocaleString() + ' تومان ' | faNum }}</td>

                        <td>{{item.strLastUpdateDate | faNum}}</td>

                        <td [ngClass]="item.bActive ? 'text-success fw-bold' : 'text-danger fw-bold' ">{{item.bActive == true ? 'فعال' : 'غیر فعال'}}</td>

                    </tr>

                </tbody>

            </table>

        </div>


    </div>

</main>

<div class="modal fade" id="newProduct" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{editMode ? ' ویرایش محصول ' : 'افزودن محصول' }}  </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>

            </div>

            <div class="modal-body row gx-2 p-2">

                <div class="col-12 col-md-4 p-2">

                    <label class="text-danger"> عنوان </label>
    
                    <input type="text" [(ngModel)]="model.strTitle" (change)="handleChange()" name="strTitle" autocomplete="off" class="form-control" />

                </div>

                <div class="col-12 col-md-4 p-2">

                    <label class="text-danger"> قیمت </label>
    
                    <input dir="ltr" type="text" [(ngModel)]="model.iPrice" (change)="handleChange()" name="iPrice" autocomplete="off" class="form-control" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  + ' تومان ' " />

                </div>

                <div class="col-12 col-md-4 p-2">

                    <label> بارکد </label>
    
                    <input dir="ltr" type="text" [(ngModel)]="model.strBarcode" (change)="handleChange()" name="strBarcode" autocomplete="off" class="form-control" />

                </div>

                <div class="col-12">

                    <label class="text-danger"> تصویر </label>

                    <input *ngIf="!model.strImage" type="text" (click)="fileInput.click()" [(ngModel)]="model.imgCaption" name="imgCaption" autocomplete="off" class="form-control" />

                    <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0]);handleChange()"/>

                    <div *ngIf="model?.strImage" class="border border-2 rounded pointer text-center" (click)="fileInput.click()">

                        <img src="{{'data:image/jpeg;base64,' + model.strImage}}" alt="" >

                    </div>

                </div>

                <div class="col-12">

                    <label> توضیحات </label>

                    <textarea (change)="handleChange()" [(ngModel)]="model.strComment" name="strComment" class="form-control"></textarea>

                </div>

                <div class="col-12 mt-2">

                    <input type="checkbox" [(ngModel)]="model.bActive" name="bActive"> <span class="mx-1"> فعال </span>

                </div>

                <div class="col-12 text-end mt-2">

                    <button class="btn px-5" [ngClass]="editMode ? 'btn-primary' : 'btn-success' " (click)="newProduct()"> {{editMode ? ' ویرایش ' : 'ذخیره'}} </button>

                </div>

                
            </div>

            <div class="modal-footer"></div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" >

    <div class="school_loading" style="z-index: 10000000000000000000000000000000000;">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>